// Third party
import * as yup from 'yup';

yup.setLocale({
  mixed: {
    required: '',
  },
});

const CreateUpdateCatalogSchema = yup.object().shape({
  item_id: yup.string().optional(),
  name: yup.string().required(''),
  type: yup.string().optional(),
  file_key: yup.string().optional(),
  created_at: yup.string().optional(),
  updated_at: yup.string().optional(),
  created_by_username: yup.string().optional(),
  updated_by_username: yup.string().optional(),
  file_content: yup.object().shape({
    hand_type: yup.string().optional(),
    asset_name: yup.string().when('$isEdit', {
      is: false,
      then: (schema) => schema.required(''),
      otherwise: (schema) => schema.notRequired()
    }),
    scale: yup.object().shape({
      X: yup.number().optional(),
      Y: yup.number().optional(),
      Z: yup.number().optional(),
    }).optional(),
    grip_offset: yup.object().shape({
      position: yup.object().shape({
        X: yup.number().optional(),
        Y: yup.number().optional(),
        Z: yup.number().optional(),
      }).optional(),
      rotation: yup.object().shape({
        X: yup.number().optional(),
        Y: yup.number().optional(),
        Z: yup.number().optional(),
        W: yup.number().optional(),
        IsIdentity: yup.boolean().optional(),
      }).optional(),
    }).optional(),
    trigger_points: yup.object().shape({
      release: yup.number().optional(),
      engaged: yup.number().optional(),
      reset: yup.number().optional(),
    }).optional(),
  }).optional(),
});

export { CreateUpdateCatalogSchema };
